module.exports = __webpack_public_path__ + "assets/img/weShare.cd50bc97.jpg";